import { CarouselFeature } from "./feature-base.js";
class SlideIndexFeature extends CarouselFeature {
  constructor(host) {
    super(host);
    this.syncViewToSlideIndex = () => {
      if (this.host.slideIndex === null)
        return;
      this.micro(() => {
        const targetIndex = Math.round(
          Math.min(
            Number(this.host.slideIndex),
            this.host.assignedChildren.length - 1
          )
        );
        if (targetIndex > -1) {
          const targetElement = this.host.assignedChildren[Number(targetIndex)];
          this.host.features.slideVisibility.controlledUpdate = true;
          this.host.scrollToSlide(targetElement, 0.5);
        }
      }, "update slide index");
    };
    host.gatherProperties(["slideIndex"], host);
    Object.defineProperty(host, "slideIndex", {
      get() {
        return host.hasAttribute("slide-index") ? Number(host.getAttribute("slide-index")) : null;
      },
      set(val) {
        if (val !== null)
          host.setAttribute("slide-index", String(val));
        else
          host.removeAttribute("slide-index");
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "slide-index" && Number(newValue) > -1) {
      this.syncViewToSlideIndex();
    }
  }
}
// Add the new attribute.
SlideIndexFeature.observedAttributes = ["slide-index"];
export {
  SlideIndexFeature
};
